export default __webpack_public_path__ + "static/media/logo.475ab6d2.jpeg";